<template>
  <div class="container">
    <div class="title">欢迎来到网上照明展</div>
    <div class="inpuBox">
      <div class="itemBox">
        <span>手机号</span>
        <input
          v-model="mobile"
          type="number"
          placeholder="请输入手机号"
          maxlength="11"
        />
      </div>
      <div class="itemBox">
        <span>验证码</span>
        <input 
          v-model="code" 
          type="number" 
          placeholder="请输入验证码" 
          style="width: 120px" 
        />
        <button
          @click.stop="getVerificationCode"
          :disabled="disabled"
        >
          {{ codename }}
        </button>
      </div>
      <div class="loginBtn" @click.stop="formSubmit">登录</div>
      <div class="other">其他登录方式</div>
      <div class="bigBox">
        <router-link class="imgBox" to="/phoneLogin">
          <div class="img">
            <img
              src="../../../static/images/icon/login.png"
              style="width: 19px; height: 20px"
            />
          </div>
          <div class="desc">账号密码登录</div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { sendSMS, mobileLogin } from "@/api/login";
export default {
  name: "codeLogin",
  data() {
    return {
      mobile: "",
      code: "",
      codename: "获取验证码",
      time: null,
      timer: 60,
      disabled: false,
    };
  },
  methods: {
    //获取验证码
    getVerificationCode() {
      if (this.mobile == "") {
        this.Common.showMsg("请输入手机号");
        return false;
      }
      this.disabled = true;
      sendSMS({ Mobile: this.mobile, Type: 1 }).then((res) => {
        this.time = setInterval(() => {
          this.getSecond(60);
        }, 1000);
      });
    },

    // 获取倒计时
    getSecond(timer) {
      this.codename = this.timer + "s后重试";
      this.timer--;
      if (this.timer > 0) {
        this.codename = this.timer + "s后重试";
      } else {
        clearInterval(this.time);
        this.disabled = false;
        this.codename = "获取验证码";
        this.timer = 60;
      }
    },

    //登录
    formSubmit() {
      var that = this;
      if (that.mobile == "") {
        that.Common.showMsg("请输入手机号");
        return false;
      }
      if (that.code == "") {
        that.Common.showMsg("请输入验证码");
        return false;
      }
      mobileLogin({ Mobile: that.mobile, Code: that.code }).then((res) => {
        // that.tim.logout();
        localStorage.token = res.Msg;
        localStorage.setItem("mid", res.Data.MemberID);
        // getImUserSig().then((sig) => {
        //   that.tim
        //     .login({
        //       userID: res.Data.MemberID.toString(),
        //       userSig: sig.Data,
        //     })
        //     .then(() => {
        //       that.loading = false;
        //       console.log("timlogin");
        //       that.$store.commit("toggleIsLogin", true);
        //       that.$store.commit("startComputeCurrent");
        //       that.$store.commit({
        //         type: "GET_USER_INFO",
        //         userID: res.Data.MemberID.toString(),
        //         userSig: sig.Data,
        //         sdkAppID: 1400356039,
        //       });
              var beforeLoginUrl = localStorage.beforeLoginUrl;
              if (beforeLoginUrl) {
                location.href = beforeLoginUrl;
                localStorage.removeItem("beforeLoginUrl");
              } else {
                that.$router.push({ path: "/" });
              }
        //       console.log("timloginend");
        //     });
        // });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  .title {
    text-align: center;
    font-size: 26px;
    color: #333;
    margin: 60px;
  }
  .inpuBox {
    .itemBox {
      height: 56px;
      line-height: 56px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #999;
      margin: 0px 37px;
      font-size: 14px;

      span{
        width: 60px;
      }
      input {
        width: calc(100% - 60px);
        border: none;
      }
      button {
        color: #666;
        border: none;
        border-left: 1px solid #ddd;
        background-color: transparent;
        width: 100px;
        height: 14px;
        line-height: 14px;
        padding-left: 10px;
      }
    }
    .loginBtn {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: rgba(235, 78, 78, 1);
      border-radius: 20px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      margin: 34px 37px 90px 37px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      -ms-border-radius: 20px;
      -o-border-radius: 20px;
    }
    .other {
      font-size: 11px;
      color: #999;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
        content: "";
        display: block;
        width: 117px;
        background-color: #ddd;
        height: 1px;
        position: absolute;
        left: 27px;
      }
      &::before {
        content: "";
        display: block;
        width: 117px;
        background-color: #ddd;
        height: 1px;
        position: absolute;
        right: 27px;
      }
    }
    .bigBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 32px;
      .imgBox {
        display: flex;
        align-items: center;
        flex-direction: column;
        .img {
          width: 40px;
          height: 40px;
          line-height: 40px;
          border: 1px solid rgba(207, 207, 207, 1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .desc {
          font-size: 12px;
          color: #999;
          margin-top: 7px;
        }
      }
    }
  }
}
</style>
